import React, { useEffect, useState } from "react";
import SitePayUI from "./SitePay.presenterNew";
import moment from "moment";
import { Formik } from "formik";
import { useRouter } from "src/hooks/useRouter";
import { useRecoilState } from "recoil";
import {
  couponCodeAtom,
  isInitAtom,
  isShowPayAtom,
  productKeyAtom,
} from "src/atoms";
import { requestCash } from "src/service/pay";
import { useModal } from "src/hooks/useModal";
import { useGetMyServiceList } from "src/hooks/api/product/useGetMyServiceList";
import { useSearchParams } from "react-router-dom";
import { useGetPriceList } from "src/hooks/api/pay/useGetPriceList";
import { useIsOciProduct } from "src/hooks/recoil/useIsOciProduct";
import { IGetInicisDataRes } from "src/service/types/pay.type";
import { useIsCashApply } from "src/hooks/recoil/useIsCashApply";
import { getProductFromSessionStorage } from "src/utils/storage/auth";
import useValidationSchemas from "src/hooks/validation/useValidationSchemas";
import PayTypeChecker from "./PayTypeChecker";
import PriceChecker from "./PriceChecker";
import { useGetCurrencyCode } from "src/hooks/api/pay/useGetCurrencyCode";
import InicisDataChecker from "./InicisDataChecker";
import { notifySuccess } from "src/components/Common/Toast";
import { useTranslation } from "react-i18next";

const SitePayContainer = () => {
  const { openTermsService, openPrivatePolicy, openPaidTermsService } =
    useModal();
  const [isShowPay, setIsShowPay] = useRecoilState(isShowPayAtom);
  const [isInit, setIsInit] = useRecoilState(isInitAtom);
  const [couponCodeInfo, setCouponCodeInfo] = useRecoilState(couponCodeAtom);
  const { isOciProduct } = useIsOciProduct();
  const [licenseCount, setLicenseCount] = useState<number>(
    isOciProduct && getProductFromSessionStorage() === "WRAPSODY_ECO" ? 1 : 10
  );
  const [payTerm, setPayTerm] = useState<string>("year");
  const [searchParams, setSearchParams] = useSearchParams();
  const [priceUid, setPriceUid] = useState<string>("");
  const [priceType, setPriceType] = useState<string>(
    searchParams.get("type") ?? "premium"
  );
  const [confirmPolicy, setConfirmPolicy] = useState<boolean>(false);
  const [cardNumber, setCardNumber] = useState<string>("");
  const [userPerPrice, setUserPerPrice] = useState<number>(0);
  const [userPerPriceYear, setUserPerPriceYear] = useState<number>(0);
  const [inicisData, setInicisData] = useState<IGetInicisDataRes>();
  const [selectPayType, setSelectPayType] = useState<"card" | "cash">("card");
  const [planId, setPlanId] = useState<string>(""); // planId --> paypal 버튼에 사용됨
  const [serviceNo, setServiceNo] = useState<number>(0);
  // const [serviceList, setServiceList] = useState<any>([]);
  const [toggleMoreInfoOn, setToggleMoreInfoOn] = useState<boolean>(false);
  const [isRenew, setIsRenew] = useState<boolean>(false);
  const [startDate, setStartDate] = useState<string>("");
  const [depositorName, setDepositorName] = useState<string>("");
  const [selectAppList, setSelectAppList] = useState<string[]>([]);
  const [showExtDetail, setShowExtDetail] = useState<boolean>(false);
  const [productKey] = useRecoilState(productKeyAtom);
  const { requestCashSchema, requestCardSchema } = useValidationSchemas({
    type: "create",
    cloudProvider: isOciProduct ? "OCI" : "AWS",
  });
  const [showTaxInvoiceFields, setShowTaxInvoiceFields] =
    useState<boolean>(false);
  const { t } = useTranslation();
  const [taxInvoiceInfo, setTaxInvoiceInfo] = useState({
    owner: "",
    businessNumber: "",
    requestDate: moment(Date.now()),
    issuer: "",
    phoneNumber: "",
    email: "",
  });
  const initialValues = {
    licenseCount: 10,
    billType: "",
    billCode: "",
    payTerm: "month",
    totalPrice: 0,
    referralId: "",
    nxacAppUids: "",
    depositor: "",
    serviceUid: "",
    payDate: "",
    upc: "",
    taxInvoice: "",
    couponCode: "",
    companyName: "",
    selectPayType: "card",
    confirmPolicy: false,
    priceType,
    priceUid,
  };
  const route = useRouter();
  const { isMyServiceLoading, serviceList } = useGetMyServiceList({}); // 가입된 서비스 여부
  // const { isPriceListLoading, priceList } = usePriceList({}); // 제품별 요금제 정보
  const { currency, payCompany, countryCode } = useGetCurrencyCode({
    product: getProductFromSessionStorage(),
  });
  const { isPriceListLoading, priceList } = useGetPriceList({
    product: getProductFromSessionStorage(),
  }); // 제품별 요금제 정보
  // 현금결제 신청한 상태인지 파악 (상태에따라 페이지 이동)
  const { isCashApply } = useIsCashApply();

  // useEffect(() => {
  //   if (
  //     licenseCount >= 10 &&
  //     licenseCount <= 9999 &&
  //     confirmPolicy &&
  //     payTerm !== "" &&
  //     priceType !== ""
  //   ) {
  //     // TODO card 유효성 체크
  //     setIsCheckPay(true);
  //   } else {
  //     setIsCheckPay(false);
  //   }
  // }, [depositorName, confirmPolicy]);

  useEffect(() => {
    setPriceType(searchParams.get("type") ?? "premium");
    // console.log("타입세팅!!@", searchParams.get("type"));
  }, [route]);
  const handleChangeTaxInvoice = (e: React.ChangeEvent<HTMLInputElement>) => {
    switch (e.target?.name) {
      case "owner":
        setTaxInvoiceInfo((prev) => ({ ...prev, owner: e.target.value }));
        break;
      case "businessNumber":
        setTaxInvoiceInfo((prev) => ({
          ...prev,
          businessNumber: e.target.value,
        }));
        break;
      case "issuer":
        setTaxInvoiceInfo((prev) => ({ ...prev, issuer: e.target.value }));
        break;
      case "phoneNumber":
        setTaxInvoiceInfo((prev) => ({ ...prev, phoneNumber: e.target.value }));
        break;
      case "email":
        setTaxInvoiceInfo((prev) => ({ ...prev, email: e.target.value }));
        break;
    }
  };
  const handleChangeTaxRequestDate = (date: Date | null) => {
    setTaxInvoiceInfo((prev) => ({ ...prev, requestDate: moment(date) }));
    // console.log("handleChangeTaxRequestDate", taxInvoiceInfo);
  };

  // planId --> paypal 버튼에 사용됨
  const changePlanId = async () => {
    // console.log("priceList", priceList);
    // console.log("priceType", priceType);
    // console.log("searchParams.get(type)", searchParams.get("type"));
    // console.log("payTerm", payTerm);
    // console.log("currency", currency);
    priceList?.find((price) => {
      if (
        price.priceType === priceType &&
        price.product === productKey &&
        price.currency === currency
      ) {
        // console.log("찾았어요~");
        // planId 세팅
        if (payTerm === "month" && price.planIdMonth) {
          setPlanId(price.planIdMonth);
          console.log("month plan Id 세팅", price.planIdMonth);
        } else if (payTerm === "year" && price.planIdYear) {
          setPlanId(price.planIdYear);
          console.log("year plan Id 세팅", price.planIdYear);
        }
        // priceUid 세팅
        if (price.priceUid) {
          setPriceUid(price.priceUid);
          console.log("priceUid 세팅", price.priceUid);
        }
      }
    });
  };

  const toggleMoreInfo = () => {
    setToggleMoreInfoOn((prev) => !prev);
  };

  const toggleTaxInvoidFields = () => {
    setShowTaxInvoiceFields((prev) => !prev);
  };

  const openExtDetailModal = (e: any, uid: string) => {
    e.preventDefault();

    setShowExtDetail(true);
    // setShowExtDetailUid(uid);
  };

  const hideExtDetailModal = () => {
    setShowExtDetail(false);
  };

  return (
    <>
      <Formik
        initialValues={initialValues}
        validationSchema={
          selectPayType === "cash" ? requestCashSchema : requestCardSchema
        }
        onSubmit={(values) => {
          const {
            licenseCount,
            payTerm,
            referralId,
            depositor,
            serviceUid,
            payDate,
            priceType,
            totalPrice,
            selectPayType,
          } = values;
          // console.log("제출 값:", values);
          // console.log(
          //   "taxInvoice:",
          //   showTaxInvoiceFields
          //     ? {
          //         ...taxInvoiceInfo,
          //         requestDate: moment(taxInvoiceInfo.requestDate).format(
          //           "YYYYMMDD"
          //         ),
          //       }
          //     : {}
          // );
          if (selectPayType === "card") {
            // createServiceBill({
            //   serviceBillUid: serviceBillUid,
            //   userCode: userInfo.userCode,
            //   billType: "PAY",
            //   billCode: priceUid, // price의 uid값 전달
            //   licenseCount: licenseCount,
            //   orderID: inicisData?.oid,
            //   subscriptionID: "inicis",
            //   payTerm,
            //   startTime,
            //   oldSubscriptionID,
            //   currency,
            //   payCompany,
            //   referralId,
            //   nxacAppUids: selectAppList,
            // });
          } else if (selectPayType === "cash") {
            // notifyError("cash");
            if (couponCodeInfo) {
              requestCash({
                billCode: priceUid,
                billType: priceType,
                depositor,
                licenseCount,
                nxacAppUids: [],
                payDate: payDate,
                payTerm,
                referralId,
                serviceUid,
                taxInvoice: showTaxInvoiceFields ? taxInvoiceInfo : {},
                totalPrice,
                // totalPrice:
                //   payTerm === "year"
                //     ? Number(
                //         (userPerPriceYear * 12 * licenseCount * 1.1).toFixed(
                //           0
                //         )
                //       ) - couponCodeInfo.discountPrice
                //     : Number((userPerPrice * licenseCount * 1.1).toFixed(0)) -
                //       couponCodeInfo.discountPrice,
                // upc: "",

                product: couponCodeInfo.product,
                couponCode: couponCodeInfo.couponCode,
              }).then(() => {
                notifySuccess(t("cashStatus.requestNotic"));
                route.goConsole();
              });
            } else {
              requestCash({
                billCode: priceUid,
                billType: priceType,
                depositor,
                licenseCount,
                nxacAppUids: [],
                payDate: payDate,
                payTerm,
                referralId,
                serviceUid,
                taxInvoice: showTaxInvoiceFields ? taxInvoiceInfo : {},
                totalPrice,
                // payTerm === "year"
                //   ? Number(
                //       (userPerPriceYear * 12 * licenseCount * 1.1).toFixed(
                //         0
                //       )
                //     )
                //   : Number((userPerPrice * licenseCount * 1.1).toFixed(0)),
                product: productKey,
              }).then(() => {
                notifySuccess(t("cashStatus.requestNotic"));
                route.goConsole();
              });
            }
          }
        }}
      >
        {(formikProps) => {
          const { confirmPolicy } = formikProps.values;
          return (
            <>
              <SitePayUI
                {...formikProps}
                confirmPolicy={confirmPolicy}
                // payApply={payApply}
                cardNumber={cardNumber}
                userPerPrice={userPerPrice}
                userPerPriceYear={userPerPriceYear}
                currency={currency}
                payCompany={payCompany}
                isInit={isInit}
                isShowPay={isShowPay}
                planId={planId}
                serviceNo={serviceNo}
                serviceList={serviceList ?? []}
                openTermsService={openTermsService}
                openPrivatePolicy={openPrivatePolicy}
                openPaidTermsService={openPaidTermsService}
                toggleMoreInfo={toggleMoreInfo}
                toggleMoreInfoOn={toggleMoreInfoOn}
                isRenew={isRenew}
                startDate={startDate}
                inicisData={inicisData}
                selectPayType={selectPayType}
                selectAppList={selectAppList}
                setSelectAppList={setSelectAppList}
                showExtDetail={showExtDetail}
                openExtDetailModal={openExtDetailModal}
                hideExtDetailModal={hideExtDetailModal}
                toggleTaxInvoidFields={toggleTaxInvoidFields}
                showTaxInvoiceFields={showTaxInvoiceFields}
                taxInvoiceInfo={taxInvoiceInfo}
                handleChangeTaxInvoice={handleChangeTaxInvoice}
                handleChangeTaxRequestDate={handleChangeTaxRequestDate}
              />
              <PayTypeChecker setSelectPayType={setSelectPayType} />
              <PriceChecker
                currency={currency}
                setPriceType={setPriceType}
                setUserPerPrice={setUserPerPrice}
                setUserPerPriceYear={setUserPerPriceYear}
                setPlanId={setPlanId}
                setPriceUid={setPriceUid}
              />
              <InicisDataChecker
                setInicisData={setInicisData}
                priceType={priceType}
                userPerPrice={userPerPrice}
                userPerPriceYear={userPerPriceYear}
              />
              {/* <button
                type="submit"
                onClick={(e) => {
                  e.preventDefault();
                  formikProps.submitForm();
                  console.log("btn values", formikProps.values);
                }}
              >
                submit
              </button> */}
            </>
          );
        }}
      </Formik>
    </>
  );
};

export default SitePayContainer;
